import { Outlet, useLocation } from 'react-router-dom';
import { useEffect, useLayoutEffect } from 'react';
import clsx from 'clsx';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { MobileBottomNav } from '@/components/MobileBottomNav';
import { PushPermissionBanner } from '@/components/PushPermissionBanner';
import { PendingPaymentBanner } from '@/components/dashboard/PendingPaymentBanner';
import { useWishlistSync } from '@/hooks/useWishlistSync';
import { pageCanvasClass } from '@/lib/listingLayout';
import { hasSeoCrawlShell } from '@/hooks/useSeoCrawlLifecycle';
import { removeRouteLcpShell, removeSeoCrawl } from '@/lib/staticHero';

export function ShellLayout() {
  useWishlistSync();
  const { pathname } = useLocation();

  // Navbar replaces the green LCP banner immediately — never stack both.
  useLayoutEffect(() => {
    removeRouteLcpShell();
  }, [pathname]);

  useEffect(() => {
    // Strip crawl HTML once React has painted a real page H1.
    let cancelled = false;
    let raf = 0;
    let tries = 0;

    const tick = () => {
      if (cancelled) return;
      const main = document.getElementById('main-content');
      if (main?.querySelector('h1')) {
        removeRouteLcpShell();
        if (hasSeoCrawlShell()) removeSeoCrawl();
        return;
      }
      if (++tries < 90) {
        raf = requestAnimationFrame(tick);
      }
    };

    raf = requestAnimationFrame(tick);
    return () => {
      cancelled = true;
      cancelAnimationFrame(raf);
    };
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col">
      <a
        href="#main-content"
        className="absolute left-4 top-0 z-50 -translate-y-full rounded-lg bg-brand-700 px-4 py-2 text-sm font-semibold text-white focus:translate-y-4 focus:outline-none"
      >
        Skip to content
      </a>
      <Navbar />
      <PushPermissionBanner />
      <main
        id="main-content"
        className={clsx('flex-1 pb-16 md:pb-0', pageCanvasClass)}
      >
        <div className="mx-auto max-w-listing px-4">
          <PendingPaymentBanner />
        </div>
        <Outlet />
      </main>
      <Footer />
      <MobileBottomNav />
    </div>
  );
}
